export default "__VITE_ASSET__qx6AIB2D__"